module.exports = __webpack_public_path__ + "static/media/disk-packing.2d18db29.gif";